import { LoginGoogleButton } from "./LoginGoogleButton";
import { LoginMethodTabs, type LoginMethod } from "./LoginMethodTabs";
import { LoginPasswordForm } from "./LoginPasswordForm";

export function LoginPasswordCard({
  methods,
  activeMethod,
  onSelectMethod,
  googleEnabled,
  loginTitle,
  loginSubtitle,
}: {
  methods: LoginMethod[];
  activeMethod: LoginMethod;
  onSelectMethod: (method: LoginMethod) => void;
  googleEnabled?: boolean;
  loginTitle?: string;
  loginSubtitle?: string;
}) {
  return (
    <section className="login-auth" aria-labelledby="login-title">
      <div className="login-card">
        <div className="login-card-heading">
          <h2 id="login-title">{loginTitle ?? "Welcome back"}</h2>
          <p className="login-description">
            {loginSubtitle ?? "Please sign in to continue to your dashboard"}
          </p>
        </div>

        <LoginMethodTabs
          methods={methods}
          active={activeMethod}
          onSelect={onSelectMethod}
        />

        <LoginPasswordForm />

        {googleEnabled && (
          <>
            <div className="login-divider my-5">
              <span>or</span>
            </div>
            <LoginGoogleButton />
          </>
        )}
      </div>
    </section>
  );
}
